import React from "react";
import "./ScheduleHero.css";

type Side = { name: string; badgeUrl?: string | null };

type Props = {
	/** "Previous Fixture" / "Next Event" — whatever this card is showing. */
	label: string;
	/** Two sides for a fixture; one image and a title for an event. */
	home?: Side;
	away?: Side;
	title?: string;
	imageUrl?: string | null;
	/** The dark strip: date, time, venue, competition. */
	strip: string;
	onView?: () => void;
};

/**
 * The card at the top of a schedule page: what just happened, and what's next.
 *
 * Those two are the questions someone opens this page with, and answering them
 * before the table means the common case needs no reading at all.
 */
export class ScheduleHero extends React.Component<Props> {
	render() {
		const { label, home, away, title, imageUrl, strip, onView } = this.props;

		return (
			<div className="sh-card">
				<div className="sh-top">
					<span className="sh-label">{label}</span>
					{onView && <button className="sh-view" onClick={onView} type="button">View</button>}
				</div>

				<div className="sh-body">
					{home || away ? (
						<div className="sh-teams">
							<div className="sh-team">
								{home?.badgeUrl && <img alt="" src={home.badgeUrl} />}
								<span>{home?.name || "Home"}</span>
							</div>
							<span className="sh-vs">vs</span>
							<div className="sh-team">
								{away?.badgeUrl && <img alt="" src={away.badgeUrl} />}
								<span>{away?.name || "Visitors"}</span>
							</div>
						</div>
					) : (
						<div className="sh-single">
							{imageUrl && <img alt="" src={imageUrl} />}
							<span>{title}</span>
						</div>
					)}
				</div>

				<div className="sh-strip">{strip}</div>
			</div>
		);
	}
}

/** Nothing scheduled — still a card, so the row doesn't collapse. */
export class ScheduleHeroEmpty extends React.Component<{ label: string; message: string }> {
	render() {
		return (
			<div className="sh-card">
				<div className="sh-top"><span className="sh-label">{this.props.label}</span></div>
				<div className="sh-body sh-empty">{this.props.message}</div>
				<div className="sh-strip">&nbsp;</div>
			</div>
		);
	}
}
